import React from 'react';
import {
  Box,
  Button,
  Flex,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';

interface ConfirmModalProps {
  isOpen: boolean;
  onClose: (isCancel?: boolean) => void;
  plate: string;
  date: string;
  id: string;
}

export const ConfirmModal = ({
  isOpen,
  onClose,
  plate,
  date,
  id,
}: ConfirmModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="2xl" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Text fontSize="20px" color="black">
            Solicitação de agendamento registrada com sucesso!
          </Text>
          <Text fontSize="14px" color="black" mt="18px">
            Em breve enviaremos a confirmação de agendamento e dados da oficina
            que irá atendê-lo
          </Text>
        </ModalHeader>
        <ModalBody>
          <Flex gap="18px">
            <Box w="full" display="flex" flexDir="column">
              <Text color="text.300" fontSize="14px" as="label">
                Placa do Veículo
              </Text>
              <Input
                readOnly
                bg="gray.200"
                border="1px solid"
                borderColor="gray.100"
                value={plate}
              />
            </Box>
            <Box w="full" display="flex" flexDir="column">
              <Text color="text.300" fontSize="14px" as="label">
                Data sugerida
              </Text>
              <Input
                readOnly
                bg="gray.200"
                border="1px solid"
                borderColor="gray.100"
                value={date?.split('-').reverse().join('/')}
              />
            </Box>

            <Box w="full" display="flex" flexDir="column">
              <Text color="text.300" fontSize="14px" as="label">
                N.º de atendimento
              </Text>
              <Input
                readOnly
                bg="gray.200"
                border="1px solid"
                borderColor="gray.100"
                value={id}
              />
            </Box>
          </Flex>
        </ModalBody>

        <ModalFooter>
          <Button onClick={() => onClose()}>Fechar</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
